import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import {
  AdminPanelSettings as AdminIcon,
  Person as EmployeeIcon,
} from '@mui/icons-material';

const RoleSelectionDialog = ({ open, onClose, onRoleSelect, user, roles }) => {
  const handleRoleSelect = (role) => {
    onRoleSelect(role);
  };

  // Determine which buttons to show based on user's roles
  const showAdminButton = roles.includes('admin') || roles.includes('itsupport');
  const showEmployeeButton = roles.includes('employee');

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1.5,
          minWidth: '320px',
          maxWidth: '400px'
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 0.5, pt: 1 }}>
        <Typography variant="h6" component="div" gutterBottom sx={{ fontWeight: 'bold', mb: 1 }}>
          Select Role
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
          You have access to multiple roles. Please select which role you want to use:
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 1, pb: 1, mt: 1 }}>
        <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center' }}>
          {/* Admin Portal Button - Show if user has admin or itsupport role */}
          {showAdminButton && (
            <Button
              variant="contained"
              size="small"
              onClick={() => handleRoleSelect('admin')}
              startIcon={<AdminIcon />}
              sx={{
                bgcolor: '#d32f2f',
                color: 'white',
                px: 2,
                py: 1,
                borderRadius: 1.5,
                textTransform: 'none',
                fontSize: '0.9rem',
                fontWeight: 'bold',
                minWidth: '120px',
                '&:hover': {
                  bgcolor: '#b71c1c',
                }
              }}
            >
              Admin Portal
            </Button>
          )}

          {/* Employee Portal Button - Show if user has employee role */}
          {showEmployeeButton && (
            <Button
              variant="contained"
              size="small"
              onClick={() => handleRoleSelect('employee')}
              startIcon={<EmployeeIcon />}
              sx={{
                bgcolor: '#1976d2',
                color: 'white',
                px: 2,
                py: 1,
                borderRadius: 1.5,
                textTransform: 'none',
                fontSize: '0.9rem',
                fontWeight: 'bold',
                minWidth: '120px',
                '&:hover': {
                  bgcolor: '#1565c0',
                }
              }}
            >
              Employee Portal
            </Button>
          )}
        </Box>
      </DialogContent>


    </Dialog>
  );
};

export default RoleSelectionDialog; 